// Major Saudi Arabian cities with key neighborhoods/districts
// Coordinates are city centers (lat, lng)
export const SAUDI_CITIES = [
  {
    id: "riyadh",
    name_ar: "الرياض",
    name_en: "Riyadh",
    region_ar: "منطقة الرياض",
    region_en: "Riyadh Region",
    lat: 24.7136,
    lng: 46.6753,
    districts: [
      { ar: "حي الملقا", en: "Al Malqa" },
      { ar: "حي النخيل", en: "Al Nakheel" },
      { ar: "حي العليا", en: "Al Olaya" },
      { ar: "حي الصحافة", en: "Al Sahafa" },
      { ar: "حي الياسمين", en: "Al Yasmin" },
      { ar: "حي الورود", en: "Al Wurud" },
      { ar: "حي الربوة", en: "Al Rabwah" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي المروج", en: "Al Muruj" },
      { ar: "حي الغدير", en: "Al Ghadir" },
      { ar: "حي الملز", en: "Al Malaz" },
      { ar: "حي السليمانية", en: "Al Sulaymaniyah" },
      { ar: "حي المربع", en: "Al Murabba" },
      { ar: "حي الشفا", en: "Al Shifa" },
      { ar: "حي النزهة", en: "Al Nuzha" },
      { ar: "حي الندى", en: "Al Nada" },
      { ar: "حي الوادي", en: "Al Wadi" },
      { ar: "حي قرطبة", en: "Qurtubah" },
      { ar: "حي الحمراء", en: "Al Hamra" },
      { ar: "حي الخزامى", en: "Al Khuzama" },
      { ar: "حي الربيع", en: "Al Rabi" },
      { ar: "حي الفلاح", en: "Al Falah" },
      { ar: "حي الازدهار", en: "Al Izdihar" },
      { ar: "حي النرجس", en: "Al Narjis" },
      { ar: "حي المصيف", en: "Al Maseef" },
      { ar: "حي الواحة", en: "Al Wahah" },
      { ar: "حي السفارات", en: "Diplomatic Quarter" },
      { ar: "حي الدرعية", en: "Diriyah" },
      { ar: "حي العارض", en: "Al Arid" },
      { ar: "حي الحزم", en: "Al Hazm" },
      { ar: "حي الفيحاء", en: "Al Fayha" },
      { ar: "حي الخليج", en: "Al Khaleej" },
      { ar: "حي الدار البيضاء", en: "Dar Al Baida" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الروابي", en: "Al Rawabi" },
      { ar: "حي الشميسي", en: "Al Shumaisi" },
      { ar: "حي المنصورة", en: "Al Mansoura" },
      { ar: "حي الشعلان", en: "Al Shalan" },
      { ar: "حي اليرموك", en: "Al Yarmuk" },
      { ar: "حي الرمال", en: "Al Rimal" },
      { ar: "حي المعذر", en: "Al Muathar" },
      { ar: "حي طويق", en: "Tuwaiq" },
      { ar: "حي الزهراء", en: "Al Zahra" },
      { ar: "حي عرقة", en: "Irqah" },
      { ar: "حي ظهرة لبن", en: "Dhahrat Laban" },
    ],
  },
  {
    id: "jeddah",
    name_ar: "جدة",
    name_en: "Jeddah",
    region_ar: "منطقة مكة المكرمة",
    region_en: "Makkah Region",
    lat: 21.4858,
    lng: 39.1925,
    districts: [
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي السلامة", en: "Al Salama" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الشاطئ", en: "Al Shati" },
      { ar: "حي الحمراء", en: "Al Hamra" },
      { ar: "حي أبحر الشمالية", en: "Obhur Al Shamaliya" },
      { ar: "حي أبحر الجنوبية", en: "Obhur Al Janubiya" },
      { ar: "حي البوادي", en: "Al Bawadi" },
      { ar: "حي النزهة", en: "Al Nuzha" },
      { ar: "حي الأندلس", en: "Al Andalus" },
      { ar: "حي الصفا", en: "Al Safa" },
      { ar: "حي المروة", en: "Al Marwah" },
      { ar: "حي الزهراء", en: "Al Zahra" },
      { ar: "حي الخالدية", en: "Al Khalidiya" },
      { ar: "حي البغدادية", en: "Al Baghdadiya" },
      { ar: "حي الفيحاء", en: "Al Fayha" },
      { ar: "حي البلد", en: "Al Balad" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
      { ar: "حي الثغر", en: "Al Thaghr" },
      { ar: "حي البساتين", en: "Al Basateen" },
      { ar: "حي المحمدية", en: "Al Mohammadiyah" },
      { ar: "حي الرحاب", en: "Al Rehab" },
      { ar: "حي الحمدانية", en: "Al Hamdaniyah" },
      { ar: "حي بريمان", en: "Briman" },
      { ar: "حي الشرفية", en: "Al Sharafiyah" },
      { ar: "حي الورود", en: "Al Wurud" },
      { ar: "حي النهضة", en: "Al Nahdah" },
      { ar: "حي مشرفة", en: "Mishrifah" },
      { ar: "حي الكورنيش", en: "Corniche" },
    ],
  },
  {
    id: "makkah",
    name_ar: "مكة المكرمة",
    name_en: "Makkah",
    region_ar: "منطقة مكة المكرمة",
    region_en: "Makkah Region",
    lat: 21.3891,
    lng: 39.8579,
    districts: [
      { ar: "حي العزيزية", en: "Al Aziziyah" },
      { ar: "حي العوالي", en: "Al Awali" },
      { ar: "حي الششة", en: "Al Shisha" },
      { ar: "حي الزاهر", en: "Al Zahir" },
      { ar: "حي الكعكية", en: "Al Kakiyah" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الرصيفة", en: "Al Raseefah" },
      { ar: "حي العتيبية", en: "Al Utaybiyah" },
      { ar: "حي الششة", en: "Al Shouqia" },
      { ar: "حي الجموم", en: "Al Jamoum" },
      { ar: "حي الفيصلية", en: "Al Faysaliyah" },
      { ar: "حي التنعيم", en: "Al Tanaim" },
      { ar: "حي بطحاء قريش", en: "Bat'ha Quraish" },
      { ar: "حي الخنساء", en: "Al Khansa" },
      { ar: "حي المسفلة", en: "Al Misfalah" },
    ],
  },
  {
    id: "madinah",
    name_ar: "المدينة المنورة",
    name_en: "Madinah",
    region_ar: "منطقة المدينة المنورة",
    region_en: "Madinah Region",
    lat: 24.5247,
    lng: 39.5692,
    districts: [
      { ar: "حي قباء", en: "Quba" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
      { ar: "حي بني ظفر", en: "Bani Dhafar" },
      { ar: "حي الحرة الشرقية", en: "Al Harrah Al Sharqiyah" },
      { ar: "حي الحرة الغربية", en: "Al Harrah Al Gharbiyah" },
      { ar: "حي الدفاع", en: "Al Difaa" },
      { ar: "حي الأزهري", en: "Al Azhari" },
      { ar: "حي العنابس", en: "Al Anabis" },
      { ar: "حي بئر عثمان", en: "Bir Othman" },
      { ar: "حي العوالي", en: "Al Awali" },
      { ar: "حي الجرف", en: "Al Jurf" },
      { ar: "حي السيح", en: "Al Sih" },
      { ar: "حي الخالدية", en: "Al Khalidiya" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي سيد الشهداء", en: "Sayed Al Shuhada" },
    ],
  },
  {
    id: "dammam",
    name_ar: "الدمام",
    name_en: "Dammam",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 26.4207,
    lng: 50.0888,
    districts: [
      { ar: "حي الشاطئ الشرقي", en: "Al Shati Al Sharqi" },
      { ar: "حي الشاطئ الغربي", en: "Al Shati Al Gharbi" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي الخليج", en: "Al Khaleej" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي النزهة", en: "Al Nuzha" },
      { ar: "حي المزروعية", en: "Al Mazrouiya" },
      { ar: "حي الجلوية", en: "Al Jalawiya" },
      { ar: "حي الأمانة", en: "Al Amanah" },
      { ar: "حي الجوهرة", en: "Al Jawhara" },
      { ar: "حي النور", en: "Al Nur" },
      { ar: "حي الفردوس", en: "Al Firdous" },
      { ar: "حي الاتصالات", en: "Al Ittisalat" },
      { ar: "حي الإسكان", en: "Al Iskan" },
      { ar: "حي البادية", en: "Al Badiyah" },
      { ar: "حي البحيرة", en: "Al Buhaira" },
    ],
  },
  {
    id: "khobar",
    name_ar: "الخبر",
    name_en: "Al Khobar",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 26.2172,
    lng: 50.1971,
    districts: [
      { ar: "حي الكورنيش", en: "Corniche" },
      { ar: "حي الراكة الشمالية", en: "Al Rakah Al Shamaliya" },
      { ar: "حي الراكة الجنوبية", en: "Al Rakah Al Janubiya" },
      { ar: "حي العقربية", en: "Al Aqrabiyah" },
      { ar: "حي الحمراء", en: "Al Hamra" },
      { ar: "حي الثقبة", en: "Al Thuqbah" },
      { ar: "حي الخزامى", en: "Al Khuzama" },
      { ar: "حي اليرموك", en: "Al Yarmuk" },
      { ar: "حي البندرية", en: "Al Bandariyah" },
      { ar: "حي الجسر", en: "Al Jisr" },
      { ar: "حي الحزام الذهبي", en: "Golden Belt" },
      { ar: "حي الروضة", en: "Al Rawdah" },
    ],
  },
  {
    id: "dhahran",
    name_ar: "الظهران",
    name_en: "Dhahran",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 26.2361,
    lng: 50.0393,
    districts: [
      { ar: "حي الدوحة الشمالية", en: "Al Doha Al Shamaliya" },
      { ar: "حي الدوحة الجنوبية", en: "Al Doha Al Janubiya" },
      { ar: "حي تهامة", en: "Tihamah" },
      { ar: "حي القصور", en: "Al Qusur" },
      { ar: "حي الجامعة", en: "Al Jamiah" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
    ],
  },
  {
    id: "bahrah",
    name_ar: "بحرة",
    name_en: "Bahrah",
    region_ar: "منطقة مكة المكرمة",
    region_en: "Makkah Region",
    lat: 21.4038,
    lng: 39.4494,
    districts: [
      { ar: "حي المروج", en: "Al Muruj" },
      { ar: "حي النزهة", en: "Al Nuzha" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي السلام", en: "Al Salam" },
      { ar: "حي الأندلس", en: "Al Andalus" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الورود", en: "Al Wurud" },
      { ar: "حي الربوة", en: "Al Rabwah" },
      { ar: "حي الحمراء", en: "Al Hamra" },
      { ar: "حي وسط المدينة", en: "City Center" },
    ],
  },
  {
    id: "taif",
    name_ar: "الطائف",
    name_en: "Taif",
    region_ar: "منطقة مكة المكرمة",
    region_en: "Makkah Region",
    lat: 21.2703,
    lng: 40.4158,
    districts: [
      { ar: "حي الشفا", en: "Al Shafa" },
      { ar: "حي الهدا", en: "Al Hada" },
      { ar: "حي الوشحاء", en: "Al Washha" },
      { ar: "حي شبرا", en: "Shubra" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي السداد", en: "Al Sadad" },
      { ar: "حي الخالدية", en: "Al Khalidiyah" },
      { ar: "حي العقيق", en: "Al Aqiq" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الوسام", en: "Al Wisam" },
    ],
  },
  {
    id: "abha",
    name_ar: "أبها",
    name_en: "Abha",
    region_ar: "منطقة عسير",
    region_en: "Asir Region",
    lat: 18.2164,
    lng: 42.5053,
    districts: [
      { ar: "حي المفتاحة", en: "Al Muftaha" },
      { ar: "حي المنسك", en: "Al Mansak" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الورود", en: "Al Wurud" },
      { ar: "حي الشفا", en: "Al Shafa" },
      { ar: "حي الموظفين", en: "Al Muwazafin" },
      { ar: "حي الأندلس", en: "Al Andalus" },
      { ar: "حي الروضة", en: "Al Rawdah" },
    ],
  },
  {
    id: "khamis",
    name_ar: "خميس مشيط",
    name_en: "Khamis Mushait",
    region_ar: "منطقة عسير",
    region_en: "Asir Region",
    lat: 18.3064,
    lng: 42.7289,
    districts: [
      { ar: "حي الراقي", en: "Al Raqi" },
      { ar: "حي الواحة", en: "Al Wahah" },
      { ar: "حي القيصومة", en: "Al Qaysumah" },
      { ar: "حي الموسى", en: "Al Musa" },
      { ar: "حي النزهة", en: "Al Nuzha" },
    ],
  },
  {
    id: "tabuk",
    name_ar: "تبوك",
    name_en: "Tabuk",
    region_ar: "منطقة تبوك",
    region_en: "Tabuk Region",
    lat: 28.3998,
    lng: 36.5700,
    districts: [
      { ar: "حي المروج", en: "Al Muruj" },
      { ar: "حي العليا", en: "Al Olaya" },
      { ar: "حي الأندلس", en: "Al Andalus" },
      { ar: "حي الورود", en: "Al Wurud" },
      { ar: "حي السليمانية", en: "Al Sulaymaniyah" },
      { ar: "حي النسيم", en: "Al Naseem" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
    ],
  },
  {
    id: "buraidah",
    name_ar: "بريدة",
    name_en: "Buraidah",
    region_ar: "منطقة القصيم",
    region_en: "Qassim Region",
    lat: 26.3260,
    lng: 43.9750,
    districts: [
      { ar: "حي الرحمانية", en: "Al Rahmaniyah" },
      { ar: "حي الصفراء", en: "Al Safra" },
      { ar: "حي المنتزه الغربي", en: "West Al Muntazah" },
      { ar: "حي الخبيب", en: "Al Khabib" },
      { ar: "حي الريان", en: "Al Rayyan" },
      { ar: "حي الفايزية", en: "Al Fayziyah" },
      { ar: "حي الإسكان", en: "Al Iskan" },
    ],
  },
  {
    id: "unayzah",
    name_ar: "عنيزة",
    name_en: "Unayzah",
    region_ar: "منطقة القصيم",
    region_en: "Qassim Region",
    lat: 26.0841,
    lng: 43.9938,
    districts: [
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي الرحاب", en: "Al Rihab" },
      { ar: "حي الخبراء", en: "Al Khubara" },
    ],
  },
  {
    id: "hail",
    name_ar: "حائل",
    name_en: "Hail",
    region_ar: "منطقة حائل",
    region_en: "Hail Region",
    lat: 27.5114,
    lng: 41.7208,
    districts: [
      { ar: "حي الخزامى", en: "Al Khuzama" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
      { ar: "حي النقرة", en: "Al Nuqrah" },
      { ar: "حي المغواة", en: "Al Maghwah" },
    ],
  },
  {
    id: "najran",
    name_ar: "نجران",
    name_en: "Najran",
    region_ar: "منطقة نجران",
    region_en: "Najran Region",
    lat: 17.4917,
    lng: 44.1322,
    districts: [
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي الأخدود", en: "Al Ukhdud" },
      { ar: "حي الفهد", en: "Al Fahd" },
      { ar: "حي السلام", en: "Al Salam" },
    ],
  },
  {
    id: "jazan",
    name_ar: "جازان",
    name_en: "Jazan",
    region_ar: "منطقة جازان",
    region_en: "Jazan Region",
    lat: 16.8892,
    lng: 42.5611,
    districts: [
      { ar: "حي الكورنيش", en: "Corniche" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي السلام", en: "Al Salam" },
      { ar: "حي الشاطئ", en: "Al Shati" },
    ],
  },
  {
    id: "yanbu",
    name_ar: "ينبع",
    name_en: "Yanbu",
    region_ar: "منطقة المدينة المنورة",
    region_en: "Madinah Region",
    lat: 24.0238,
    lng: 38.1895,
    districts: [
      { ar: "حي الشاطئ", en: "Al Shati" },
      { ar: "حي النخيل", en: "Al Nakheel" },
      { ar: "حي الزهراء", en: "Al Zahra" },
      { ar: "حي الندى", en: "Al Nada" },
    ],
  },
  {
    id: "hafr",
    name_ar: "حفر الباطن",
    name_en: "Hafr Al Batin",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 28.4337,
    lng: 45.9601,
    districts: [
      { ar: "حي السلام", en: "Al Salam" },
      { ar: "حي الملك فهد", en: "King Fahd" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
    ],
  },
  {
    id: "jubail",
    name_ar: "الجبيل",
    name_en: "Jubail",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 27.0046,
    lng: 49.6458,
    districts: [
      { ar: "حي الفناتير", en: "Al Fanateer" },
      { ar: "حي الدانة", en: "Al Danah" },
      { ar: "حي الحويلات", en: "Al Huwaylat" },
      { ar: "حي الروضة", en: "Al Rawdah" },
      { ar: "حي الدفي", en: "Al Defi" },
    ],
  },
  {
    id: "arar",
    name_ar: "عرعر",
    name_en: "Arar",
    region_ar: "منطقة الحدود الشمالية",
    region_en: "Northern Borders",
    lat: 30.9758,
    lng: 41.0381,
    districts: [
      { ar: "حي البلدية", en: "Al Baladiyah" },
      { ar: "حي الملك فيصل", en: "King Faisal" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
    ],
  },
  {
    id: "sakaka",
    name_ar: "سكاكا",
    name_en: "Sakaka",
    region_ar: "منطقة الجوف",
    region_en: "Al Jawf Region",
    lat: 29.9697,
    lng: 40.2000,
    districts: [
      { ar: "حي الشلهوب", en: "Al Shalhoub" },
      { ar: "حي الفيصلية", en: "Al Faisaliyah" },
      { ar: "حي العزيزية", en: "Al Aziziyah" },
    ],
  },
  {
    id: "al-ahsa",
    name_ar: "الأحساء",
    name_en: "Al Ahsa",
    region_ar: "المنطقة الشرقية",
    region_en: "Eastern Province",
    lat: 25.3830,
    lng: 49.5915,
    districts: [
      { ar: "حي الهفوف", en: "Al Hofuf" },
      { ar: "حي المبرز", en: "Al Mubarraz" },
      { ar: "حي الرقيقة", en: "Al Ruqayqah" },
      { ar: "حي الكوت", en: "Al Kut" },
      { ar: "حي النعاثل", en: "Al Naathel" },
      { ar: "حي الإسكان", en: "Al Iskan" },
      { ar: "حي المزروعية", en: "Al Mazrouiya" },
      { ar: "حي الخالدية", en: "Al Khalidiyah" },
    ],
  },
];

export const findCity = (id) => SAUDI_CITIES.find((c) => c.id === id);
